import produce from 'immer';
import { Reducer } from 'redux';

import { Stage, Mission, MissionsState, MissionsTypes } from '../types';

const initialState: MissionsState = {
    isLoading: false,
    missions: [],
};

const missionsReducer: Reducer<MissionsState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case MissionsTypes.GET_LIST: {
                draft.isLoading = false;
                draft.missions = action.payload.missions;
                break;
            }
            case MissionsTypes.REQUEST_GET_LIST: {
                draft.isLoading = true;
                break;
            }
            case MissionsTypes.SAVE_MISSION: {
                draft.isLoading = false;
                draft.missions = action.payload.mission
                    ? draft.missions.find((item) => item.id === action.payload.mission.id)
                        ? draft.missions.map((item) => {
                              return item.id === action.payload.mission.id
                                  ? { ...action.payload.mission, stages: item.stages }
                                  : item;
                          })
                        : [...draft.missions, action.payload.mission]
                    : [...draft.missions];
                break;
            }
            case MissionsTypes.REQUEST_SAVE_MISSION: {
                draft.isLoading = true;
                break;
            }
            case MissionsTypes.SAVE_STAGE: {
                draft.isLoading = false;
                draft.missions = updateStages(action.payload.missionId, [...state.missions], action.payload.stage);
                break;
            }
            case MissionsTypes.REQUEST_SAVE_STAGE: {
                draft.isLoading = true;
                break;
            }
            case MissionsTypes.UPDATE_REWARDS: {
                draft.isLoading = false;
                draft.missions = draft.missions.map((mission) => {
                    return mission.id === action.payload.missionId
                        ? { ...mission, rewards: action.payload.rewards }
                        : mission;
                });
                break;
            }
            case MissionsTypes.REQUEST_UPDATE_REWARDS: {
                draft.isLoading = true;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

const updateStages = (missionId: string, missions: Mission[], stage?: Stage) => {
    const mission = missions.find((item) => item.id === missionId);
    if (!mission || !stage) return [...missions];

    const existingStage = mission.stages?.find((item) => item.id === stage.id);

    if (!existingStage)
        return [
            ...missions.map((c) => {
                return c.id !== mission.id ? c : { ...mission, stages: [...mission.stages, stage] };
            }),
        ];
    return [
        ...missions.map((c) => {
            return c.id !== mission.id
                ? c
                : {
                      ...mission,
                      stages: mission.stages.map((st) => {
                          return st.id === stage.id ? stage : st;
                      }),
                  };
        }),
    ];
};

export { missionsReducer };
